import axiosClient from '@/config/api/axios'
import { CONVERSATIONS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'
import { conversationToThread } from './conversationMappers'
import { invalidateConversationSearch } from './invalidateConversationSearch'

export async function createThread(thread, options = {}) {
  if (!isApiConfigured()) return null
  const body = { id: thread.id, title: thread.title, project_id: thread.projectId ?? null }
  const { data } = await axiosClient.post(CONVERSATIONS, body, { signal: options.signal })
  invalidateConversationSearch()
  return conversationToThread(data)
}

export async function updateThreadTitle(id, title, options = {}) {
  if (!isApiConfigured()) return null
  const { data } = await axiosClient.patch(`${CONVERSATIONS}/${id}`, { title }, { signal: options.signal })
  invalidateConversationSearch()
  return conversationToThread(data)
}

export async function updateThreadModel(id, model, options = {}) {
  if (!isApiConfigured()) return null
  const { data } = await axiosClient.patch(`${CONVERSATIONS}/${id}`, { model }, { signal: options.signal })
  invalidateConversationSearch()
  return conversationToThread(data)
}

export async function deleteThread(id) {
  if (!isApiConfigured()) return null
  await axiosClient.delete(`${CONVERSATIONS}/${id}`)
  invalidateConversationSearch()
  return true
}
